import { getMetricForEvent } from '@fullstory/signal-studio-context';
import { Event } from '@fullstory/proto/fs/api/segment';
import { useMemo } from 'react';
import { useMetricComputations } from '@fullstory/library-ui';
import { hashObject } from '@fullstory/util/hash';
import { buildTrendPoint } from '@fullstory/visualizations';
import { isNonNull } from '@fullstory/typeutils';
import { DisplayPrecision } from '@fullstory/proto/fs/services/webber/frontend/display';

export const useMetricsTrendData = (
  event: Event | null,
  timeRange: { startTime: string; endTime: string },
) => {
  const suggEventId = useMemo(() => hashObject(event), [event]);
  const metric = useMemo(() => {
    if (!event) {
      return null;
    }

    return getMetricForEvent({ event, timeRange });
  }, [event, timeRange]);

  const { responses } = useMetricComputations(metric, !!metric, `trend-metric-${suggEventId}`);

  const trendPoints = useMemo(() => {
    const computeMetricResponses = responses.flatMap(r => r.data);

    const current = computeMetricResponses
      .filter(r => !r?.isPast)
      .map(r => r?.data)
      .filter(isNonNull);

    return current.flatMap((data, parentIndex) =>
      data.table
        .map((dataItem, i) =>
          buildTrendPoint(
            dataItem,
            parentIndex,
            i,
            { displayPrecision: DisplayPrecision.PRECISION_0 },
            null,
          ),
        )
        .filter(isNonNull),
    );
  }, [responses]);

  return { trendPoints };
};
